// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3ObjK","header":"MergedInvoice_header__2xi3J"};